<section
	class="driver-report"
	[attr.data-phase]="phase()"
	[attr.aria-busy]="
		phase() === 'generating' || phase() === 'loading' ? true : null
	"
	[attr.aria-labelledby]="titleId"
>
	<div class="flex w-full flex-wrap items-center gap-4">
		<span
			class="ai-mark"
			aria-hidden="true"
			[class.is-thinking]="
				phase() === 'generating' || phase() === 'loading'
			"
		>
			<tui-icon icon="@tui.sparkles" />
		</span>

		<div class="min-w-0 flex-1 basis-64">
			<h3 class="text-base font-semibold text-primary" [id]="titleId">
				{{ 'analysis.driver-report.title' | transloco }}
			</h3>
			<p
				class="status whitespace-pre-line text-sm text-primary-dark-300"
				aria-live="polite"
				[class.is-error]="phase() === 'error'"
				[attr.role]="phase() === 'error' ? 'alert' : null"
				[attr.aria-hidden]="phase() === 'loading' ? true : null"
			>
				@if (phase() === 'loading') {
					<span class="status-skeleton" [tuiSkeleton]="true"></span>
				} @else if (phase() === 'error') {
					<span class="block truncate">
						{{ 'analysis.driver-report.error' | transloco }}
					</span>
				} @else {
					{{ 'analysis.driver-report.description' | transloco }}
				}
			</p>
			@if (phase() === 'loading') {
				<p class="sr-only" aria-live="polite">
					{{ 'analysis.driver-report.loading' | transloco }}
				</p>
			}
		</div>

		@if (phase() === 'loading') {
			<span
				class="action-skeleton ml-auto shrink-0"
				[tuiSkeleton]="true"
				aria-hidden="true"
			></span>
		} @else if (phase() === 'generating') {
			<mar-insight-progress
				class="ml-auto"
				[percent]="progressPercent()"
				[text]="progressMessage()"
				[fallback]="'analysis.driver-report.progress' | transloco"
			/>
		} @else if (phase() === 'view') {
			<button
				tuiButton
				type="button"
				size="s"
				appearance="outline"
				class="ml-auto shrink-0"
				data-action="view"
				(click)="onView()"
			>
				{{ 'analysis.driver-report.view' | transloco }}
			</button>
		} @else if (phase() === 'ready' || phase() === 'error') {
			<button
				tuiButton
				type="button"
				size="s"
				appearance="primary"
				class="ml-auto shrink-0"
				data-action="generate"
				[disabled]="!canGenerate()"
				(click)="onGenerate()"
			>
				{{
					(phase() === 'error'
						? 'action.retry'
						: 'analysis.driver-report.generate'
					) | transloco
				}}
			</button>
		}
	</div>

	<mar-insight-panel
		[open]="panelOpen()"
		[title]="'analysis.driver-report.title' | transloco"
		[description]="'analysis.driver-report.description' | transloco"
		[context]="contextKey() | transloco"
		[meta]="meta()"
		[message]="narrative()"
		(closed)="onClosePanel()"
	/>
</section>
